import Documentzero_table_interface_schema from "../../../interface/Documentzero_table_interface_schema";

export const NotaCreditoSchema: Documentzero_table_interface_schema = {
  numero: true,
  data: true,
  filiale: true,
  tipoB2b: true,
  titolo: true,
  cognome: true,
  nome: true,
  indirizzo: true,
  citta: true,
  cap: true,
  prov: true,
  stato: true,
  codfiva: true,
  partitaIva: true,
  codiceDestinatarioB2b: true,
  pecDocumenti: true,
  pagamento: true,
  riferimento: true,
  bancaAppoggio: true,
  annotazioni: true,
  scadenzerate: false,
  speseTrasporto: true,
  codiceIvaSpeseTrasporto: true,
  ivaSpeseTrasporto: true,
  speseImballo: true,
  codiceIvaSpeseImballo: true,
  ivaSpeseImballo: true,
  speseRivalsa: true,
  codiceIvaSpeseRivalsa: true,
  ivaSpeseRivalsa: true,
  speseBolli: true,
  codiceIvaSpeseBolli: true,
  ivaSpeseBolli: true,
  arrotondamento: true,
  codiceIvaArrotondamento: true,
  ivaArrotondamento: true,
  //id: false,
  //siglaDocumento: false,
  //codiceFiliale: false,
  //operatore: false,
  //dataReg: false,
  //dispositivo: false,
  //scontrinoFiscale: false,
  //dataScontrino: false,
  //scontrinoFiscale2: false,
  //dataScontrino2: false,
  ragioneSociale: true,
  //codiceControparte: false,
  //codiceCausale: false,
  causale: true,
  porto: true,
  //dataInizio: false,
  //oraInizio: false,
  //peso: false,
  //colli: false,
  //aspetto: false,
  //mezzo: false,
  //destinazione: false,
  //destinazioneIndirizzo: false,
  //destinazioneCitta: false,
  //destinazioneCap: false,
  //destinazioneProvincia: false,
  //codiceVettore: false,
  //vettore: false,
  //vettoreIndirizzo: false,
  //note: false,
  //testoAggiuntivo: false,
  //imponibileIva1: false,
  //imponibileIva2: false,
  //imponibileIva3: false,
  //imponibileIva4: false,
  //imponibileIva5: false,
  //imponibileIva6: false,
  //iva1: false,
  //iva2: false,
  //iva3: false,
  //iva4: false,
  //iva5: false,
  //iva6: false,
  //codiceIva1: false,
  //codiceIva2: false,
  //codiceIva3: false,
  //codiceIva4: false,
  //codiceIva5: false,
  //codiceIva6: false,
  //importoIva1: false,
  //importoIva2: false,
  //importoIva3: false,
  //importoIva4: false,
  //importoIva5: false,
  //importoIva6: false,
  //esigibilitaIva1: false,
  //esigibilitaIva2: false,
  //esigibilitaIva3: false,
  //esigibilitaIva4: false,
  //esigibilitaIva5: false,
  //esigibilitaIva6: false,
  totale: true,
  //matricola: false,
  //euro: false,
  //campo1_d: false,
  spese: true,
  ivaSpese: true,
  //codiceIvaSpese: false,
  //bloccaPagamenti: false,
  //codicePagamento: false,
  //tipoControparte: false,
  //controllato: false,
  //statoContabile: false,
  //fatturato: false,
  //codiceAzienda: false,
  ragioneSocialeAz: true,
  //indirizzoAz: false,
  //cittaAz: false,
  //capAz: false,
  //provAz: false,
  //codfivaAz: false,
  //partitaIvaAz: false,
  //infoagg1Az: false,
  //infoagg2Az: false,
  //regminsanitaAz: false,
  ragioneSocialeNe: true,
  indirizzoNe: true,
  cittaNe: true,
  capNe: true,
  provNe: true,
  //codfivaNe: false,
  //partitaIvaNe: false,
  //infoagg1Ne: false,
  //infoagg2Ne: false,
  //regminsanitaNe: false,
  //filialeRicavo: false,
  //filialeCosto: false,
  //codiceMagazzino: false,
  //campo2_d: false,
  //campo3_d: false,
  //stampato: false,
  annullato: true,
  //tipoOperazione: false,
  //destinazioneStato: false,
  //totalequantita: false,
  //codiceDistributore: false,
  //bancaaziendanome: false,
  //bancaaziendafiliale: false,
  //bancaaziendaiban: false,
  //codiceTransazione: false,
  //codiceTransazioneReso: false,
  opposizioneSts: true,
  numeroDocumentoReso: true,
  dataDocumentoReso: true,
  //dispositivoDocumentoReso: false,
  //statoSts: false,
  //siglaDocumentoMaster: false,
  //codiceDocumentoMaster: false,
  //statoSts2: false,
  //partitaIvaSts: false,
  //indirizzo1b: false,
  //statoB2b: false,
  //elettronica: false,
  //erroreB2b: false,
  //art73: false,
  //rea_ufficio: false,
  //rea_numerorea: false,
  //rea_capsoc: false,
  //rea_sociounico: false,
  //rea_statoliquid: false,
  //rf_idpaese: false,
  //rf_idcodice: false,
  //rf_codfisc: false,
  //rf_denominazione: false,
  //rf_nome: false,
  //rf_cognome: false,
  //so_indirizzo: false,
  //so_cap: false,
  //so_comune: false,
  //so_provincia: false,
  //so_nazione: false,
  //ti_idpaese: false,
  //ti_idcodice: false,
  //ti_codfisc: false,
  //ti_denominazione: false,
  //ti_nome: false,
  //ti_cognome: false,
  //rf_idpaeseAz: false,
  //rf_idcodiceAz: false,
  //rf_codfiscAz: false,
  //rf_denominazioneAz: false,
  //rf_nomeAz: false,
  //rf_cognomeAz: false,
  //so_indirizzoAz: false,
  //so_capAz: false,
  //so_comuneAz: false,
  //so_provinciaAz: false,
  //so_nazioneAz: false,
  //nazioneAz: false,
  //regimefiscale: false,
  //formatotrasmissione: false,
  //dataB2b: false,
  //tipoImpresa: false,
  //dataOperazione: false,
  //nomeAz: false,
  //cognomeAz: false,
  //tipoImpresaAz: false,
  //resaIndirizzo: false,
  //resaCap: false,
  //resaCitta: false,
  //resaProv: false,
  //resaNazione: false,
  //codiceEori: false,
  //codiceEoriAz: false,
  //soggettoEmittente: false,
  //eMail: false,
  //rf_eori: false,
  //ti_eori: false,
  //telefonoAz: false,
  //faxAz: false,
  //eMailAz: false,
  //telefonoNe: false,
  //faxNe: false,
  //eMailNe: false,
  //idPortale: false,
  //portale: false,
  //tipoRitenuta: false,
  //importoRitenuta: false,
  //aliquotaRitenuta: false,
  //causaleRitenuta: false,
  //percentualeImponibileRitenuta: false,
  //tipoCassa1: false,
  //aliquotaCassa1: false,
  //importoCassa1: false,
  //imponibileCassa1: false,
  //ivaCassa1: false,
  //codiceIvaCassa1: false,
  //percentualeImponibileCassa1: false,
  //ritenutaCassa1: false,
  //riferimentoCassa1: false,
  //tipoCassa2: false,
  //aliquotaCassa2: false,
  //importoCassa2: false,
  //imponibileCassa2: false,
  //ivaCassa2: false,
  //codiceIvaCassa2: false,
  //percentualeImponibileCassa2: false,
  //ritenutaCassa2: false,
  //riferimentoCassa2: false,
  //cassaPrevidenziale: false,
  //ritenuta: false,
  //subtotale: false,
  //causaleFe: false,
}
